export const style = {
  icon: {
    sx: (color: string) => {
      return {
        '& .MuiSvgIcon-root': {
          color,
          height: '19px',
          width: '19px',
          marginTop: '4px',
        },
      };
    },
  },
  MenuList: {
    flex: {
      display: 'flex',
    },
    sx: {
      '& .MuiMenuItem-root': {
        display: 'flex',
        alignItems: 'center',
        pl: '9px',
        pr: '9px',
      },
      '& .MuiListItemIcon-root': {
        mr: 0.5,
      },
    },
  },
} as const;
